import { render, staticRenderFns } from "./AprovalCampaign.vue?vue&type=template&id=208e450a&scoped=true"
import script from "./AprovalCampaign.vue?vue&type=script&lang=js"
export * from "./AprovalCampaign.vue?vue&type=script&lang=js"
import style0 from "./AprovalCampaign.vue?vue&type=style&index=0&id=208e450a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208e450a",
  null
  
)

export default component.exports